class BrandCarouselSection extends HTMLElement {
  connectedCallback() {
    this.sliderSelector = '[data-brand-carousel]';
    this.fallbackSpeed = 0.5;
    this.splideExtensions = window.splide?.Extensions || {};

    if (!Array.isArray(this.splideInstances)) {
      this.splideInstances = [];
    }

    this.mountSliders();
  }

  disconnectedCallback() {
    this.destroySliders();
  }

  getSectionSpeed() {
    const parsedSpeed = Number(this.dataset.sliderSpeed);
    return Number.isFinite(parsedSpeed) ? parsedSpeed : this.fallbackSpeed;
  }

  getSliderSpeed(sliderElement, sectionSpeed) {
    const sliderSpeed = Number(sliderElement.dataset.autoscrollSpeed);
    return Number.isFinite(sliderSpeed) && sliderSpeed !== 0 ? sliderSpeed : sectionSpeed;
  }

  getOptions(speed) {
    return {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      perPage: 5,
      gap: '25px',
      fixedWidth: '200px',
      autoScroll: {
        speed,
      },
      arrows: false,
      pagination: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      breakpoints: {
        767: {
          perPage: 3,
          fixedWidth: null,
          gap: '12px',
        },
      },
    };
  }

  mountSliders() {
    if (typeof Splide === 'undefined') {
      return;
    }

    const sectionSpeed = this.getSectionSpeed();
    this.querySelectorAll(this.sliderSelector).forEach((sliderElement) => {
      if (!sliderElement || sliderElement.dataset.mounted === 'true') {
        return;
      }

      const splide = new Splide(sliderElement, this.getOptions(this.getSliderSpeed(sliderElement, sectionSpeed)));
      splide.mount(this.splideExtensions);
      sliderElement.dataset.mounted = 'true';
      this.splideInstances.push({ sliderElement, splide });
    });
  }

  destroySliders() {
    if (!Array.isArray(this.splideInstances) || this.splideInstances.length === 0) {
      return;
    }

    this.splideInstances.forEach(({ sliderElement, splide }) => {
      if (splide && typeof splide.destroy === 'function') {
        splide.destroy(true);
      }

      if (sliderElement && sliderElement.dataset) {
        delete sliderElement.dataset.mounted;
      }
    });

    this.splideInstances = [];
  }
}

if (!customElements.get('brand-carousel-section')) {
  customElements.define('brand-carousel-section', BrandCarouselSection);
}
